export default __webpack_public_path__ + "static/media/rocket_boy.f5ca8c91.svg";